import "../styles/LatestNews.scss";
import { useState, useEffect } from "react";
import { FaPlay } from "react-icons/fa";
import Title from "./common/Title";

const LatestNews = ({ news = [] }) => {
  const [selectedNews, setSelectedNews] = useState(null);

  // ✅ Set the first news item once news data is available
  useEffect(() => {
    if (news.length > 0 && !selectedNews) {
      setSelectedNews(news[0]);
    }
  }, [news, selectedNews]);

  const sideNews = news.filter((item) => item.id !== selectedNews?.id);

  const handleCardClick = (item) => {
    setSelectedNews(item);
  };

  return (
    <div className="latest-news-section">
      <Title text="LATEST NEWS" />
      <div className="container">
        <div className="latest-news-content row">
          {/* LEFT SIDE — Shows currently selected main card */}
          {selectedNews && (
            <div
              className="main-news-card col-md-6"
              onClick={() => handleCardClick(selectedNews)}
            >
              <div
                className="main-news-image"
                style={{ backgroundImage: `url(${selectedNews.thumbnail})` }}
              >
                {selectedNews.video && (
                  <div className="play-button">
                    <FaPlay />
                  </div>
                )}
                <div className="main-news-info">
                  <span className="news-date">
                    {new Date(selectedNews.created_at).toLocaleDateString()}
                  </span>
                  <h3 className="news-title">{selectedNews.heading}</h3>
                  <p className="">{selectedNews.content}</p>
                </div>
              </div>
            </div>
          )}

          {/* RIGHT SIDE — Details + other small side news cards */}
          <div className="side-news-list col-md-6">
            {/* {selectedNews && (
              <div className="side-news-card active">
                <div
                  className="side-news-image"
                  style={{ backgroundImage: `url(${selectedNews.thumbnail})` }}
                />
                <div className="side-news-info">
                  <h4 className="news-title">{selectedNews.heading}</h4>
                  <span className="news-date">
                    {new Date(selectedNews.created_at).toLocaleDateString()}
                  </span>
                  <p className="news-description">{selectedNews.content}</p>
                </div>
              </div>
            )} */}

            {/* OTHER NEWS CARDS */}
            {sideNews.length > 0 &&
              sideNews && sideNews.map((item) => (
                <div
                  className="side-news-card small"
                  key={item.id}
                  onClick={() => handleCardClick(item)}
                >
                  <div
                    className="side-news-image"
                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                  />
                  <div className="side-news-info">
                    <h4 className="news-title">{item.heading}</h4>
                    <span className="news-date">
                      {new Date(item.created_at).toLocaleDateString()}
                    </span>
                    <p className="">{item.content}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
